// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5 1.8H11C12.1 1.8 13 2.7 13 3.8V12.2C13 13.3 12.1 14.2 11.05 13.85C9.85 13.45 8.75 13.25 7.6 13.75C6.2 14.35 5.25 14.5 4.3 14.1C3.5 13.76 3 13.2 3 12.3V3.8C3 2.7 3.9 1.8 5 1.8Z',
  'M10.01 5.36H7.4C6.46 5.36 5.81 5.89 5.81 6.68C5.81 7.47 6.46 8 7.4 8H8.6C9.54 8 10.19 8.53 10.19 9.32C10.19 10.11 9.54 10.64 8.6 10.64H5.99',
  'M8 4.1V11.9',
];
